// extracted by mini-css-extract-plugin
export var attachment = "_id-a";
export var emailContainer = "_id-4";
export var emailContentPaddedContainer = "_id-b";
export var emailHeader = "_id-6";
export var emailIframe = "_id-3";
export var emailInfoIcon = "_id-9";
export var emailShortenedSummary = "_id-e";
export var infoDropdown = "_id-0";
export var infoRowBoundedContent = "_id-d";
export var internal = "_id-5";
export var merchant = "_id-8";
export var messageInputContainer = "_id-h";
export var normal = "_id-7";
export var replyCard = "_id-f";
export var subtleButton = "_id-1";
export var subtleButtonIconContainer = "_id-2";
export var toggleViewRepliesButton = "_id-c";
export var wrappingText = "_id-g";